import { LeftOutlined } from '@ant-design/icons'
import { GraviButton } from '@gravitate-js/excalibrr'
import { Link } from 'react-router-dom'

interface BackButtonProps {
  bookType?: 'Cost' | 'Revenue'
}

export function BackButton({ bookType }: BackButtonProps) {
  const returnPath = bookType === 'Cost' ? '/freight/carrier_books' : '/freight/ratebooks'

  return (
    <Link to={returnPath}>
      <GraviButton appearance='link' icon={<LeftOutlined />} buttonText='Back to Ratebooks' />
    </Link>
  )
}
